import LoyaltyRankProgressbar, {
  LoyaltyRankProgressbarProps,
} from "components/molecules/LoyaltyRankProgressbar";
import "./styles.sass";
import useTranslate from "../../../hooks/useTranslate";

type LoyaltyRankProgressProps = LoyaltyRankProgressbarProps;

const LoyaltyRankProgressBig = (props: LoyaltyRankProgressProps) => {
  const t = useTranslate();

  return (
    <div className="LoyaltyRankProgressBig">
      <h3 className="LoyaltyRankProgressBig__title">
        {t("loyalty.rank.rank-progress.title")}
      </h3>
      <LoyaltyRankProgressbar {...props} />
    </div>
  );
};

export default LoyaltyRankProgressBig;
